export default __webpack_public_path__ + "static/media/Ward of the Arch Lector.d2d42ee9.jpg";